import React from "react";
import Reveal from "react-reveal/Reveal";
import PropTypes from "prop-types";
import styles from "./animation.scss";

const Animation = (props) => {
  let passedStyle = styles["fade-in-up"];
  if (props.className) {
    passedStyle = props.className;
  }
  return <Reveal effect={passedStyle}>{props.children}</Reveal>;
};

Animation.propTypes = {
  children: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default Animation;
